/**
 * App to show and filter references
 * - Not sure if the routing does anything anymore
 * - Listing DOM is fully re-rendered everytime filters are changed
 */
import { FixedNavigation } from './FixedNavigation';
import { Movax } from './Movax';

var director = require('director'),
    Router = director.Router,
    Mustache = require('mustache'),
    $ = require('jquery');

interface Options {
  'scrollToActiveSingleView': boolean
}

/**
 * MapApp
 * @class
 */
export class MapApp {

  public $el;
  private root: string;
  private routes;
  private router;
  private viewsLoadedCount: number = 0;
  public containerId;

  private rootViewTemplate;
  private singleViewTemplate;
  private filterListTemplate;
  private rootViewAjaxFunction;
  private singleViewAjaxFunction;
  private singleViewCallback;
  private filteringCallback;
  private activeView;
  private viewActiveClass;
  private settings: Options;
  private listGroups: Array<Object>;
  private filteredListItems: Array<Object>;
  private filters: Object;
  private loaderVisibleClass;

  private dom = {
    '$mainView': null,
    '$singleView': null,
    '$activeView': null,
    '$loader': null,
    '$list': null,
    '$filterListHolder': null,
    '$filterList': null,
    '$filtersHolder': null,
    '$filters': null
  };

  constructor(public containerSelector, public containerClass, private options?:Options) {

    this.$el = $(this.containerSelector);
    this.root = this.$el.data('root').replace(/\/$/, '');

    if (!this.$el.length) {
      throw new Error('OnePageApp#constructor: containerSelector - element not found');
    }

    this.containerId = this.$el.attr('id');
    //
    //super(containerSelector);

    this.settings = {
      'scrollToActiveSingleView': false
    };

    if(options) {
      this.settings.scrollToActiveSingleView = options.scrollToActiveSingleView ||  false;
    }

  }

  public init() {
    this._setupRouting();
    this._initFilterList();
  }

  private _startRouting() {
    var self = this,
      currentRoute,
      initialViewRoot = false;

    if (this.routes) {
      this.router = Router(this.routes);

      // use html5 history if found
      this.router.configure({
        'html5history': true,
        'run_handler_in_init': false
      });

      currentRoute = '/' + this.router.getRoute().join('/').replace(/\/$/, '');
      this.router.init(currentRoute);

      if (this.root === currentRoute) {
        initialViewRoot = true;
      }

      // capture clicks and do routing
      this.$el.on('click', 'a', function(e) {
        var $this = $(this),
            href = $(this).attr('href');

        // if this link is within our one page app, use routing, otherwise treat as normal link (do nothing)
        if (href.indexOf(self.root) === 0) {
          e.preventDefault();

          if ($this.data('type') === 'back' && self.viewsLoadedCount > 1) {
            //console.log('views loaded, back native');
            history.back();
          } else {
            //console.log('loading new view');

            // Remove suffix slash just in case (director requirement)
            self.router.setRoute($(this).attr('href').replace(/\/$/, ''));
          }

        }
      });
    }
  }

  /**
   * Render items based on active filters
   * FIltering callback is in referenceApp module. Maybe these could be combined.
   */
  private _applyFilters() {
    var filteredList = this.filteringCallback(this.filters, this.listGroups);
    const categoryTemplate = $('#' + this.containerId + '__category-template').html();
    const referenceCardTemplate = $('#' + this.containerId + '__card-template').html();

    const markUp = Mustache.render(categoryTemplate,
      {
        groups: filteredList,
        buttonText: 'Read more',
      },
      {referenceCard: referenceCardTemplate}
    );

    this.dom.$filterList.html(markUp);

    const loadMore = $('.js-load-more-references');
    $.each(loadMore, (i, el) => {
      $(el).closest('.category-group').find('.v3-references-list__col').length <= 4 ? $(el).hide() : [];
    });
    loadMore.on('click', function() {
      $(this).closest('.category-group').addClass('open');
      $(this).hide();
    });

    if (window.location.hash) {
      const target = document.querySelector(window.location.hash) as HTMLElement;
      if (target) {
        setTimeout(() => {
          target.scrollIntoView(true);
        }, 1000);
      }
    }

    // reset filters by product group
    this._filterByProductGroup(filteredList);
  }

  /**
   * Handle items filtering by product group ('Pile drivers' , 'Piling hammers' etc.)
   */
  private _filterByProductGroup(filteredList) {
    const selectTags = document.querySelectorAll('select[name="machine-type"]');

    // keeps current state of productGroup filters accross categories ( {ROAD: ['Pile drivers', 'Piling hammers']})
    let filterState = {};

    // single option select tags respond to clicks otherwise act as usual ('input')
    selectTags.forEach(tag => {
        const tagEvent = (tag  as HTMLSelectElement).options.length > 1 ? 'input' : 'click';
        tag.addEventListener(tagEvent, handleFilter, {once: tagEvent === 'click' ? true : false})
    });

    function handleFilter(e) {
      const el = e.target as HTMLSelectElement;
      const filtered = el.parentElement.nextElementSibling;
      const selected = el.selectedOptions[0];
      const category = el.getAttribute('data-category');
      selected.hidden = true;

      filterState[category] ?
      filterState[category].push(selected.value) :
      filterState[category] = [selected.value] ;

      renderButton(el, selected, filtered);
      renderResults(category);
      el.selectedIndex = 0;
    }

    function renderButton(element, selected, filtered) {
      const template = $('#js-map-app__category-template').html();
      const btn = document.createElement('button');
      const category = element.getAttribute('data-category');
      btn.innerHTML = Mustache.render(template, {selected: element.value.toUpperCase()} );
      filtered.appendChild(btn);

      btn.addEventListener('click', resetGroupFilter.bind(this, btn, selected, category));
    }

    function resetGroupFilter(btn, selected, category) {
      if (selected.nextElementSibling || selected.previousElementSibling) {
        selected.hidden = false;
      } else {
        selected.parentElement.addEventListener('click', handleFilter, {once: true})
      }

      let index = filterState[category].indexOf(selected.value);

      if (filterState[category].length === 1 ) {
        delete filterState[category];
      } else if (index > -1) {
        filterState[category].splice(index, 1)
      }
      renderResults(category);
      btn.remove();
    }

    function renderResults(category) {
      const cardTemplate = $('#js-map-app__card-template').html();
      const refsDiv = document.querySelector(`div[data-category="${category}"]`);

      filteredList.forEach(list => {
        // use filterState to filter group relevant items for a specified category
        if (list.name === category) {
          let itemsToRender = {};
          if (filterState[category]) { // group filters applied hence build itemsToRender from valid cases

            list.items.forEach(item => {
              if (item.productGroups) {
                if (item.productGroups.some(group => filterState[category]?.includes(group))) {
                  itemsToRender[item.id] = item;
                }
              }
            });
          } else if (filterState[category] === undefined) { // no group filters applied hence include all items
            itemsToRender = Object.assign({}, list.items);
          }
          refsDiv.innerHTML = Mustache.render(cardTemplate, { items: Object.values(itemsToRender), buttonText: 'Read more'});

          const loadMoreBtn = refsDiv.nextElementSibling.firstElementChild;
          // console.log(refsDiv.children.length);

          refsDiv.children.length <= 4 ? loadMoreBtn.classList.add('hidden') : loadMoreBtn.classList.remove('hidden');
        };
      });
    }
  }

  /**
   * Parse filter string to type and name
   * @param {string} str  filter sring containing type and name, ie category###road
   * @returns {object}
   */
  private _parseFilter(str:String) {
    var arr = str.split('###'),
        filter = {};

    filter[arr[0]] = arr[1];

    return filter;
  }

  /**
   * Remove filter from the filters list
   * @param obj
   * @param type
   */
  private _removeFilter(obj, type) {
    var key, index;

    for(key in obj) {
      if (obj.hasOwnProperty(key)) {
        switch (type) {
          case 'multiple':

            if (this.filters[key]) {
              index = this.filters[key].indexOf(obj[key]);
              if(index !== -1) {
                this.filters[key].splice(index, 1);
              }
            }

            // And delete array if this was last filter
            if (this.filters[key].length === 0) {
              delete this.filters[key];
            }
            break;
        }
      }
    }
    //update list
    this._applyFilters();
  }

  /**
   * Add filter to the filters list
   * @param obj
   * @param type
   */
  private _addFilter(obj, type, applyNow) {
    var key;

    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        switch(type) {
          case 'multiple':

            if(!this.filters[key]) {
              this.filters[key] = [];
            }

            this.filters[key].push(obj[key]);
            break;
        }
      }
    }

    if(!applyNow) {
      return;
    }
    //update list
    this._applyFilters();
  }

  /**
   * Render items to DOM and start filtering
   * @param groups {Object[]} List of categories and items
   */
  private _startFiltering(groups) {
    var self = this,
        filterActiveClass = 'button--active',
        scrollToFilters = false;

    this.listGroups = groups;

    this.dom.$filters.on('click', function() {
      var $this = $(this);

      if ($this.hasClass(filterActiveClass)) {
        $this.removeClass(filterActiveClass);
        self._removeFilter(self._parseFilter($this.data('filter')), $this.data('filter-type'));
      } else {
        $this.addClass(filterActiveClass);
        self._addFilter(self._parseFilter($this.data('filter')), $this.data('filter-type'), true);
      }
    });

    this._applyFilters();
  }

  private _scrollToFilters() {
    var self = this;

    Movax.events.waitForWindowLoad().then(function() {
      $('body, html').stop().animate({
        'scrollTop': self.dom.$filterListHolder.offset().top
      }, 600);
    });
  }

  /**
   * Init filter list
   * Init filters and get items from backend
   */
  private _initFilterList() {
    var self = this,
        filterActiveClass = 'button--active',
        scrollToFilters = false;

    this.dom.$filterListHolder = this.$el.find('#' + this.containerId + '__filter-list-holder');
    this.dom.$filterList = this.$el.find('#' + this.containerId + '__filter-list');
    this.dom.$filtersHolder = this.$el.find('#' + this.containerId + '__filters');
    this.dom.$filters = this.dom.$filtersHolder.find('.js-' + this.containerClass + '__filter');

    this.filters = {};

    // Check if we have filters that need to be activated on inititaton
    this.dom.$filters.each(function() {
      var $this = $(this),
        needsInit = $this.data('filter-init-active');

      if (needsInit) {
        scrollToFilters = true;
        $this.addClass(filterActiveClass);
        self._addFilter(self._parseFilter($this.data('filter')), $this.data('filter-type'), false);
      }

    });

    // Scroll to filters if any of the filters are active
    if(scrollToFilters) {
     this._scrollToFilters();
    }


    // Wait for visibility and then fetch data
    if(this.dom.$filterList.length) {
      // Movax.dom.waitForVisibility(this.dom.$filterList[0]).then(function (res) {
        Movax.xhr.get(self.$el.data('filter-list-ajax-url')).then(function(res) {
          self._startFiltering(res);
        });
      // });
    }
  };

  private _initToggleListToggler() {
    var self = this,
        itemHolderClass = self.containerClass + '__list-item-holder',
        itemHolderOpenClass = itemHolderClass + '--open';

    this.dom.$list = this.$el.find('#' + this.containerId + '__list');

    this.dom.$list.on('click', '.' + this.containerId + '__list-toggler', function() {
      var $toggler = $(this),
          $expandables = self.dom.$list.find('.' + itemHolderClass + '[data-item-group="' + $toggler.data('group-id') + '"]');


      if (!$toggler.hasClass('opened')) {
        $toggler.addClass('opened');
        $expandables.addClass(itemHolderOpenClass);
      } else {
        $toggler.removeClass('opened');
        $expandables.removeClass(itemHolderOpenClass);
      }
    });
  }

  /**
   * Show main view or details view based on path (not sure if this is in use/working)
   */
  private _setupRouting() {
    var self = this,
        routes = {},
        routesRoot = this.$el.data('root'),
        singleViewTemplate = $('#' + this.containerId + '__single-view-template').html(),
        singleViewAjaxUrl = this.$el.data('single-view-ajax-url'),
        routerInitiated = false; // don't trigger redraws on first call since we're

    Mustache.parse(singleViewTemplate);

    this.dom.$singleView = $('#' + this.containerId + '__app-view--single');
    this.dom.$mainView = $('#' + this.containerId + '__app-view--main');

    this._setActiveView(this.$el.data('active-view'));
    this.viewActiveClass = this.containerClass + '__app-view--active';

    this.dom.$loader = $('#' + this.containerId + '__loader');
    this.loaderVisibleClass = this.containerClass + '__loader--visible';

    if(this.settings.scrollToActiveSingleView) {
      this._scrollToActiveSingleView();
    }

    routesRoot = routesRoot.replace(/\/$/, '');

    routes[routesRoot] = {
      on: function() {
        self._activateMainView();
        self.updateViewsLoadedCount();
        Movax.events.triggerResize();

        if(routerInitiated) {
          //console.log('root route');

        } else {
          routerInitiated = true;
        }

      },
      '/:slug': function(slug) {
        self._showLoader();
        self.updateViewsLoadedCount();
        Movax.events.triggerResize();

        Movax.xhr.get(singleViewAjaxUrl, { 'slug': slug }).then(function(res) {
          if (res) {
            self._hideLoader();
            self._activateSingleView(singleViewTemplate, res);
          }
        });
        if (routerInitiated) {
          //console.log('slug route');

        } else {
          routerInitiated = true;
        }

      }
    };

    this.setRoutes(routes);
  }

  private _showLoader() {
    this.dom.$loader.addClass(this.loaderVisibleClass);
  }

  private _hideLoader() {
    this.dom.$loader.removeClass(this.loaderVisibleClass);
  }

  private _scrollToActiveSingleView() {
    var self = this,
        offsetTop = 0,
        offset = self.dom.$activeView.offset().top;

    //console.log('FixedNavigation.isShown()' + FixedNavigation.isShown());
    if(FixedNavigation.isShown()) {
      offset = offset - FixedNavigation.getHeight();
    }

    if(this._getActiveView() === 'single') {
      Movax.events.waitForWindowLoad().then(function() {
        self._scrollTo(offset);
      });
    }
  }

  private _scrollTo(offset) {
    var self = this;

    $('body, html').stop().animate({
      'scrollTop': offset
    }, {
      'step': function(now, fx) {
        offset = self.dom.$activeView.offset().top;

        if (FixedNavigation.isShown()) {
          offset = offset - FixedNavigation.getHeight();
        }

        if (fx.end !== offset) {
          self._scrollTo(offset);
        }
      }
    }, 2000);
  }

  private _setActiveView(view) {
    this.activeView = view;
    this.dom.$activeView = $('#' + this.containerId + '__app-view--' + view);
  }

  private _getActiveView() {
    return this.activeView;
  }

  private _activateView(view) {
    if(view !== this.activeView) {

      this.dom.$activeView.removeClass(this.viewActiveClass);

      switch(view) {
        case 'single':
          this.dom.$singleView.addClass(this.viewActiveClass);
          break;
        case 'main':
          this.dom.$mainView.addClass(this.viewActiveClass);
          break;
      }

      this._setActiveView(view);
    }
  }

  private _activateMainView() {
    this._activateView('main');
  }

  private _activateSingleView(template, data) {

    this._activateView('single');
    this.dom.$singleView.html(Mustache.render(template, data));

    if (this.settings.scrollToActiveSingleView) {
      this._scrollToActiveSingleView();
    }

    // Stuff you need to do after single view data has been rendered, view html as parameter
    if (this.singleViewCallback) {
      this.singleViewCallback(this.dom.$singleView[0]);
    }
  }

  public setSingleViewActiveCallback(callback:Function) {
    if (typeof callback === 'function') {
      this.singleViewCallback = callback;
    }
  }

  public setFilteringHandler(handler: (filters: Object, items) => void)  {
    if (typeof handler === 'function') {
      this.filteringCallback = handler;
    }
  }

  public getViewData(template, data) {
    return Mustache.render(template, data);
  }

  public updateViewsLoadedCount() {
    this.viewsLoadedCount++;
  }

  public setRoutes(routes) {
    this.routes = routes;
  }
}
